import apiClient from './client';
import type {
  GlossaryTerm,
  CreateGlossaryTermRequest,
  BulkGlossaryImportRequest,
  BulkGlossaryImportResponse,
} from '../types';

export const glossaryApi = {
  getBySeries: async (seriesId: string): Promise<GlossaryTerm[]> => {
    const response = await apiClient.get<GlossaryTerm[]>(`/glossary/${seriesId}`);
    return response.data;
  },

  create: async (seriesId: string, data: CreateGlossaryTermRequest): Promise<{ id: string }> => {
    const response = await apiClient.post<{ id: string }>(`/glossary/${seriesId}`, data);
    return response.data;
  },

  update: async (seriesId: string, id: string, data: CreateGlossaryTermRequest): Promise<{ id: string }> => {
    const response = await apiClient.put<{ id: string }>(`/glossary/${seriesId}/${id}`, data);
    return response.data;
  },

  delete: async (seriesId: string, id: string): Promise<void> => {
    await apiClient.delete(`/glossary/${seriesId}/${id}`);
  },

  bulkImport: async (seriesId: string, data: BulkGlossaryImportRequest): Promise<BulkGlossaryImportResponse> => {
    const response = await apiClient.post<BulkGlossaryImportResponse>(`/glossary/${seriesId}/bulk`, data);
    return response.data;
  },
};



